module.exports = __webpack_public_path__ + "static/media/129.67a3125e.jpg";